var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveTrafficLaneRestriction = function SvgLiveTrafficLaneRestriction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    d: "M12.009 22.08c5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10s-10 4.477-10 10c0 5.522 4.477 10 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.56,
    d: "M17.072 7.383H6.929a.982.982 0 0 0-.982.982v4.929c0 .542.44.982.982.982h10.143c.542 0 .982-.44.982-.982V8.365a.982.982 0 0 0-.982-.982ZM9.053 14.276v2.5M14.652 14.276v2.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.33 8.865-.714.893-1.866 2.34-.714.893H9.714l.67-.893 1.866-2.34.714-.893h1zM11.09 8.865l-.742.893-1.857 2.34-.714.893H7.42v-1.268L8.99 9.758l.714-.893h.992zM16.616 8.865v1.242l-.893 1.125-.687.866-.714.893h-1.366l.714-.893 1.866-2.34.714-.893z"
  })));
};
export default SvgLiveTrafficLaneRestriction;